<div bsModal #modal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="modal" aria-hidden="true"
  [config]="{ignoreBackdropClick: true, keyboard: false}" (onShown)="onShown()">
  <div class="modal-dialog modal-xl">
    <mat-progress-bar *ngIf="isBusy" mode="indeterminate"></mat-progress-bar>
    <div class="card modal-content" *ngIf="form">
      <form (ngSubmit)="save()" [formGroup]="form">
        <div class="header">
          <button type="button" class="close" (click)="close()">
            <span aria-hidden="true">&times;</span>
          </button>
          <h2>Template Meta - Componente</h2>
        </div>
        <div class="modal-body">
          <div class="alert alert-danger" *ngIf="errors.length > 0">
            <h3>Oops! Algo deu errado:</h3>
            <ul>
              <li *ngFor="let error of errors">{{ error }}</li>
            </ul>
          </div>
          <div class="row">
            <div class="col-md-2">
              <mat-form-field>
                <mat-label>Ordem</mat-label>
                <input matInput formControlName="order" type="number" />
              </mat-form-field>
            </div>
            <div class="col-md-4">
              <mat-form-field>
                <mat-label>Tipo</mat-label>
                <mat-select formControlName="tipo">
                  <mat-option *ngFor="let item of typesService.metaMsgTemplateComponentTypes" [value]="item.value">
                    {{item.text}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-md-6">
              <mat-form-field>
                <mat-label>Formato</mat-label>
                <mat-select formControlName="format">
                  <mat-option [value]="null">Nenhum</mat-option>
                  <mat-option *ngFor="let item of typesService.metaMsgTemplateComponentFormatTypes" [value]="item.value">
                    {{item.text}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <mat-form-field>
                <mat-label>Texto</mat-label>
                <textarea matInput formControlName="text" rows="5" maxlength="1000"></textarea>
                <mat-hint align="end">Máx 1000 caracteres</mat-hint>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <mat-form-field>
                <mat-label>Exemplo JSON</mat-label>
                <textarea matInput formControlName="exampleJson" rows="4" maxlength="2000" readonly></textarea>
                <mat-hint align="end">Gerado automaticamente a partir dos parâmetros</mat-hint>
              </mat-form-field>
            </div>
          </div>
          <div class="row" *ngIf="componentPermiteParametros()">
            <div class="col-md-12">
              <div class="d-flex align-items-center justify-content-between" style="margin-bottom: 10px;">
                <h3 style="margin: 0;">Parâmetros do componente ({{parametros.length}})</h3>
                <div>
                  <button mat-stroked-button color="primary" type="button" (click)="gerarParametros()" class="button-row">
                    <mat-icon>auto_fix_high</mat-icon>
                    <span> Gerar pelo texto</span>
                  </button>
                  <button mat-stroked-button color="primary" type="button" (click)="gerarExampleJson()" class="button-row">
                    <mat-icon>code</mat-icon>
                    <span> Gerar JSON</span>
                  </button>
                </div>
              </div>
              <table class="table table-bordered table-striped table-hover" style="width: 100%;" *ngIf="parametros.length > 0">
                <thead>
                  <tr>
                    <th class="text-center" width="90">Ordem</th>
                    <th class="text-center" width="220">Nome</th>
                    <th class="text-center" width="220">Exemplo</th>
                    <th class="text-center" width="220">Origem</th>
                    <th class="text-center">Descrição</th>
                    <th class="text-center" width="80"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let parametro of parametros"
                    [class.danger]="parametro.nome?.length > parametroNomeMaxLength || (templateConfirmacaoPresenca && !isOrigemSuportada(parametro.origem))">
                    <td>
                      <input matInput type="number" min="1" [(ngModel)]="parametro.ordem"
                        [ngModelOptions]="{standalone: true}" readonly />
                    </td>
                    <td>
                      <input matInput type="text" [maxlength]="parametroNomeMaxLength" [(ngModel)]="parametro.nome"
                        [ngModelOptions]="{standalone: true}" readonly />
                    </td>
                    <td>
                      <input matInput type="text" maxlength="500" [(ngModel)]="parametro.exemplo"
                        [ngModelOptions]="{standalone: true}" readonly />
                    </td>
                    <td>
                      <span *ngIf="parametro.origem">{{parametro.origem}}</span>
                      <span *ngIf="!parametro.origem" class="text-danger">Não configurada</span>
                    </td>
                    <td>
                      <input matInput type="text" maxlength="500" [(ngModel)]="parametro.descricao"
                        [ngModelOptions]="{standalone: true}" readonly />
                    </td>
                    <td class="text-center">
                      <button mat-icon-button type="button" (click)="editParametro(parametro)" matTooltip="Editar parâmetro">
                        <mat-icon>edit</mat-icon>
                      </button>
                      <button mat-icon-button type="button" (click)="removeParametro(parametro)" matTooltip="Excluir">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="footer">
          <button mat-flat-button [disabled]="!form.valid" type="submit" color="primary" class="button-row">
            <span> Salvar</span>
          </button>
          <button mat-stroked-button type="button" [routerLink]="" (click)="close()" class="button-row">
            <span> Cancelar</span>
          </button>
        </div>
      </form>
      <app-meta-msg-template-component-parametro-modal #parametroModal (modalSave)="onParametroSave($event)"
        [origemObrigatoria]="templateConfirmacaoPresenca">
      </app-meta-msg-template-component-parametro-modal>
    </div>
  </div>
</div>
